import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsentStatus } from './CookieConsent';
import { GA4_ID, FB_PIXEL_ID, GOOGLE_ADS_ID } from '@/lib/analytics';

const GA4_CONFIGURED = GA4_ID !== 'G-XXXXXXXXXX';

function loadGoogleTag() {
  if (document.getElementById('google-tag-script')) return;
  const s = document.createElement('script');
  s.id = 'google-tag-script';
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(s);

  const s2 = document.createElement('script');
  s2.id = 'google-tag-init';
  s2.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GOOGLE_ADS_ID}');
    ${GA4_CONFIGURED ? `gtag('config', '${GA4_ID}', { send_page_view: false });` : ''}
  `;
  document.head.appendChild(s2);
}

function loadFBPixel() {
  if (document.getElementById('fb-pixel-script')) return;
  const s = document.createElement('script');
  s.id = 'fb-pixel-script';
  s.textContent = `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
    (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${FB_PIXEL_ID}');
  `;
  document.head.appendChild(s);
}

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    fbq?: (...args: any[]) => void;
  }
}

export const TrackingScripts: React.FC = () => {
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);

  // Load scripts if consent already given, or on consent event
  useEffect(() => {
    const init = () => {
      if (getConsentStatus() === 'accepted' && !loaded) {
        loadGoogleTag();
        loadFBPixel();
        setLoaded(true);
      }
    };
    init();
    window.addEventListener('cookie-consent-accepted', init);
    return () => window.removeEventListener('cookie-consent-accepted', init);
  }, [loaded]);

  // Track page views on route change
  useEffect(() => {
    if (!loaded) return;
    // GA4 page view
    if (GA4_CONFIGURED) window.gtag?.('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
    // FB PageView
    window.fbq?.('track', 'PageView');
  }, [location, loaded]);

  return null;
};
